import { consoleLogger } from '@shared/logging/consoleLogger';
import { idConnectStorage } from '@idConnect/helpers/idConnectStorage';
import { IdConnectConfiguration } from '@idConnect/types';
import { getStorageIdGraphData } from '@idConnect/helpers/getStorageIdGraphData';
import { getAllIdGraphEntries } from '@idConnect/helpers/getAllIdGraphEntries';

export const getIdGraphData = (
  entryKey: string | Array<string> | undefined,
  idConnectConfiguration: IdConnectConfiguration,
) => {
  if (
    !idConnectConfiguration ||
    Object.keys(idConnectConfiguration).length === 0
  ) {
    return {
      isSuccessful: false,
      errorMessage: 'No configuration set up',
    };
  }

  if (Array.isArray(entryKey)) {
    const allIdGraphData = getAllIdGraphEntries(idConnectConfiguration);
    if (entryKey.length === 0) {
      return {
        isSuccessful: true,
        data: allIdGraphData,
      };
    } else if (entryKey.length === 1) {
      return {
        isSuccessful: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - It doesn't allow string mapping, but the overhead for proper typing is too much, as the unit tests are enough
        data: allIdGraphData?.map((entry) => entry[entryKey[0]]),
      };
    } else {
      return {
        isSuccessful: true,
        data: allIdGraphData?.map((entry) =>
          Object.fromEntries(
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore - It doesn't allow string mapping, but the overhead for proper typing is too much, as the unit tests are enough
            entryKey.map((key) => [key, entry[key]]),
          ),
        ),
      };
    }
  }

  const idConnectDataObject = idConnectStorage(
    idConnectConfiguration.IDCONNECT_STORAGE_TYPE,
  ).get(idConnectConfiguration.IDCONNECT_DATA_STORAGE);

  if (!Array.isArray(idConnectDataObject?.connectId?.idGraph)) {
    return {
      isSuccessful: false,
      errorMessage:
        'No required IDC data present. Cannot extract the ID graph entry',
    };
  }
  const idGraphData = getStorageIdGraphData(idConnectConfiguration);
  if (!entryKey) {
    // Returns the full id Graph object with the TTL for empty parameter
    return {
      isSuccessful: true,
      data: idGraphData,
    };
  }

  if (idGraphData && typeof entryKey === 'string' && idGraphData[entryKey]) {
    if (entryKey === 'atid') {
      consoleLogger.logInfo(
        'If you are running the Utiq Web SDK from iOS webview, soon ATT will be required to acquire the atid',
      );
      return {
        isSuccessful: true,
        data: idGraphData.atid,
      };
    }
    return { isSuccessful: true, data: idGraphData[entryKey] };
  }
  return {
    isSuccessful: false,
    errorMessage: `Could not find an entry for provided entry name: ${entryKey}`,
  };
};
